import React from 'react'
import {
  Button,
} from 'components/atoms'
import PropTypes from 'prop-types'
import { Toast } from 'containers'
import { useEditorContext, actions } from 'context/EditorContext';
import { produce } from 'immer'
import { useDispatch } from 'react-redux'
import { saveDraft } from 'redux/draftsSlice'
import { useParams, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify';
import { generateEditorPath } from 'services/generators'

const EditorCopyModules = ({ hasModules, hasOtherLanguage, otherLanguageContent }) => {
  const { pageId, lang, subweb } = useParams()
  const history = useHistory()

  const [{ pageLiveData }, dispatch] = useEditorContext();
  const dispatchRedux = useDispatch()


  const handleCopyContent = () => {
    const pageWithModule = produce(pageLiveData, draftState => {
      // eslint-disable-next-line no-param-reassign
      otherLanguageContent.forEach((item) => {
        draftState.push(item)
      });
    })
    dispatch({
      type: actions.PAGE_DATA_UPDATE,
      data: pageWithModule,
    });
    dispatchRedux(saveDraft({ pageId, content: pageWithModule, lang }))
    const moduleId = `${module.key}-${pageWithModule.length - 1}`
    history.push(generateEditorPath({
      lang, pageId, subweb, moduleId
    }))
    toast.success(
      <Toast
        type="success"
        title="Conteudo importado"
        description={`${lang}` === 'pt' ? 'Conteudo importado da versão Inglesa' : 'Conteudo importado da versão Portuguesa'}
      />
    );
  }
  return (
    <>
      {!hasModules && hasOtherLanguage && (
        // eslint-disable-next-line react/jsx-props-no-multi-spaces
        <Button modifiers={['dark']} /* icon="fal fa-copy" */ onClick={handleCopyContent}>
              Copiar página
          {lang === 'pt' ? ' Inglesa' : ' Portuguesa'}
        </Button>
      )}
    </>
  )
}


EditorCopyModules.propTypes = {
  hasModules: PropTypes.bool,
  hasOtherLanguage: PropTypes.bool,
  otherLanguageContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array])

}

EditorCopyModules.defaultProps = {
  hasModules: true,
  hasOtherLanguage: false,
  otherLanguageContent: null
}

export default EditorCopyModules
